<template>
  <div id="app" :style="{backgroundColor:custombgcolor?custombgcolor:'#FFFFFF'}">
  <!-- <div id="app"> -->
		<NavBar
			v-isWeChatBrowser
			v-show="!showTab"
			@click-left="cancelFillModal"
			style="background:#F39200"
		>
			<template #title>
				<span style="color:#FFFF;">{{title}}</span>
			</template>
			<template #left>
				<van-icon name="wap-home" color="#FFFFFF" size="20px" />
			</template>
		</NavBar>
    
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import {  NavBar } from "vant";
export default {
  components: {
    NavBar,
  },
  watch: {
    $route(newvalue, oldvalue) {
      this.title = newvalue.meta.title;
    },
  },
  computed: {
    ...mapState({
      showSpin: (state) => state.app.showSpin,
      custombgcolor: (state) => state.app.custombgcolor,
    }),
    showFill: {
      get() {
        return this.$store.state.app.showFill;
      },
      set(val) {
        this.$store.commit("toggleShowFill", val);
      },
    },
  },
  data() {
    return {
      title: "",
      activeTab: 0,
      showTab: true,
			
			isshow: true,
			
    };
  },
  methods: {
    cancelFillModal() {
      this.showFill = false;
      this.$storage.get("home").then(
        (router) => {
          if (!!router) {
            this.$router.push(router);
          } else {
            this.$router.push({ name: "index" });
          }
        },
        () => {
          this.$router.push({ name: "index" });
        }
      );
    },
  },
	created(){
		// console.log("666666", this.$route)
		
	},
  mounted() {
  },
};
</script>
<style lang="less">
@import "./App.less";
</style>
<style lang="less" scoped>
.footer {
  img {
    width: 1.8rem;
    height: 0.71rem;
  }
}
</style>
